import { create } from 'zustand';
import type { McpServiceAuthRequiredData } from 'features/chat/types/chat';

/**
 * Transient state for MCP service (Swagger-derived MCP) chat-stream events.
 * Populated from the chat SSE switch on `auth_required` and consumed by `McpServiceAuthModal`.
 */
interface McpServiceChatState {
  pendingAuth: McpServiceAuthRequiredData | null;
  /** Re-dispatches the pending user turn; registered by the chat page. */
  resume: (() => void | Promise<void>) | null;
  setResume: (resume: (() => void | Promise<void>) | null) => void;
  setPendingAuth: (auth: McpServiceAuthRequiredData) => void;
  clearPendingAuth: () => void;
}

export const useMcpServiceChatStore = create<McpServiceChatState>((set) => ({
  pendingAuth: null,
  resume: null,
  setResume: (resume) => set({ resume }),
  setPendingAuth: (auth) => set({ pendingAuth: auth }),
  clearPendingAuth: () => set({ pendingAuth: null }),
}));
